module.exports = __webpack_public_path__ + "files/127ab9a07f730425ac4d4a0f4bbda472.png";